import React, { useCallback, useEffect, useRef, useState } from 'react'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import TableListing from '../../components/TableListing/TableListing'
import Pagination from '../../components/Pagination'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { Dropdown, Form, InputGroup } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as DeclineIcon } from '../../assets/images/decline.svg'
import { ReactComponent as ApproveIcon } from '../../assets/images/approve-icon.svg'
import { ReactComponent as DeleteIcon } from '../../assets/images/delete-icon-new.svg'
import { ReactComponent as IconView } from '../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import Swal from 'sweetalert2'
import { designerview } from '../../config/routingConsts'
import { useNavigate } from 'react-router-dom'
import ImageZoomModal from '../../components/ImageZoomModal/ImageZoomModal'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'

const DesignerManagement = () => {
    const navigate = useNavigate()

   const [imageShow,setImageShow] = useState(false)
   const [imageGet,setImageGet] = useState(false)

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')

    const { register, handleSubmit } = useForm()

    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    
    useEffect(()=>{
        setCurrentPage(1)
     },[searchKeyword])

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    function handleDelete(materialId) {
        mutationDelete.mutate(materialId)
        setIsDeleteModal(false)
    }

    async function deleteMaterialId(sellerId) {
        return await requestApi.post(`vendor/delete`, {
            sellerId
        })
    }

    const mutationDelete = useMutation(deleteMaterialId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('designerList')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function VendorList({ queryKey }) {
        return requestApi
            .post(
                `vendor/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: '',
                    sortBy: 1
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data,isLoading } = useQuery({
        queryKey: [
            'designerList',
            currentPage,
            DataLimit,
            searchKeyword,
            sorting[0]
        ],
        queryFn: VendorList
    })

    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data])

    
    useEffect(()=>{
        setCurrentPage(1)
     },[searchKeyword])

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    function onStatusChange(e) {
        if (e.detail == 2) {
            alert('hello')
        }
    }


    
    const handleImageZoomModal=(imagePath)=>{
        setImageShow(true)
        setImageGet(imagePath)
    }

    //#region  Table columns
    const columnHelper = createColumnHelper()

    const columns = [
        columnHelper.display({
            id: 'profilePic',
            header: 'Image',
            enableSorting: false,
            cell: (row) => {
                return (
                    <div className='product-thumbnail'>
                        <img
                            src={row?.row?.original?.profilePic}
                            alt="vendor_Img"
                            onClick={()=> handleImageZoomModal(row?.row?.original?.profilePic)}
                        />
                    </div>
                )
            }
        }),
        
        columnHelper.accessor((row) => row?.sellerUniqueId, {
            id: 'sellerUniqueId',
            header: () => 'Desiger ID',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.sellerUniqueId
                            ? row?.row?.original?.sellerUniqueId
                            : '-'}
                    </span>
                )
            }
        }),
        
        columnHelper.accessor((row) => row?.fullName, {
            id: 'fullName',
            header: () => 'Name',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.fullName
                            ? row?.row?.original?.fullName
                            : '-'}
                    </span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.storeName, {
            id: 'storeName',
            header: () => 'Store Name',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.storeName
                            ? row?.row?.original?.storeName
                            : '-'}
                    </span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.gst, {
            id: '   gst',
            header: () => 'GST No',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.gst
                            ? row?.row?.original?.gst
                            : '-'}
                    </span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.phoneNo, {
            id: 'phoneNo',
            header: () => 'Phone No',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.phoneNo
                            ? '+' +
                              row?.row?.original?.countryCode +
                              ' ' +
                              row?.row?.original?.phoneNo
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.email, {
            id: 'email',
            header: () => 'Email',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.email
                            ? row?.row?.original?.email
                            : '-'}
                    </span>
                )
            }
        }),

        columnHelper.accessor((row) => row?.totalProduct, {
            id: 'totalProduct',
            header: () => 'Total Products',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.totalProduct
                            ? <b>{row?.row?.original?.totalProduct}</b>
                            : '-'}
                    </span>
                )
            }
        }),

        // columnHelper.accessor((row) => row?.status, {
        //     id: 'status',
        //     header: () => 'Status',
        //     enableSorting: false,
        //     cell: (row) => {
        //         switch (row?.row?.original?.status) {
        //             case 7:
        //                 return (
        //                     <span className="pending-data status-data">
        //                         Pending
        //                     </span>
        //                 )
        //                 case 5:
        //                     return (
        //                         <span className="decline-data status-data">
        //                             Decline
        //                         </span>
        //                     )

        //             default:
        //                 return (
        //                     <>
        //                         <label className="switch">
        //                             <input
        //                                 type="checkbox"
        //                                 checked={
        //                                     row?.row?.original?.status == 1
        //                                         ? true
        //                                         : false
        //                                 }
        //                                 onChange={(e) =>
        //                                     onStatusChange(
        //                                         row?.row?.original?.sellerId
        //                                     )
        //                                 }
        //                             />
        //                             <span className="slider round"></span>
        //                         </label>
        //                     </>
        //                 )
        //         }
        //     }
        // }),

        columnHelper.display({
            id: 'Action',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <div className="action-data">
                            {row?.row?.original?.status == 7 ? (
                                <>
                                    <div
                                        className={`table-action ${
                                            row?.row?.original?.sellerId ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onMouseLeave={() => setopenAction(null)}
                                    >
                                        <div
                                            className={`action-btn ${
                                                row?.row?.original?.sellerId ===
                                                openAction
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            onClick={() =>
                                                OpenAction(
                                                    row?.row?.original?.sellerId
                                                )
                                            }
                                        >
                                            <IconsDots />
                                        </div>
                                        <div className="action-panel two-action">
                                            <div
                                                className="action-btn-icon edit"
                                                onClick={() => {
                                                    handleApproveDecline(
                                                        row?.row?.original
                                                            ?.sellerId
                                                    )
                                                }}
                                            >
                                                <IconApproveRight />
                                            </div>
                                            <div
                                                className="action-btn-icon delete"
                                                onClick={() =>
                                                    handleApproveDecline(
                                                        row?.row?.original
                                                            ?.sellerId
                                                    )
                                                }
                                            >
                                                <IconDesapproveClose />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div
                                        className={`table-action ${
                                            row?.row?.original?.sellerId ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onMouseLeave={() => setopenAction(null)}
                                    >
                                        <div
                                            className={`action-btn ${
                                                row?.row?.original?.sellerId ===
                                                openAction
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            onClick={() =>
                                                OpenAction(
                                                    row?.row?.original?.sellerId
                                                )
                                            }
                                        >
                                            <IconsDots />
                                        </div>
                                        <div className="action-panel two-action">
                                            <div
                                                className="action-btn-icon view"
                                                onClick={() => {
                                                    navigate(
                                                        `${designerview}/${row?.row?.original?.sellerId}`
                                                    )
                                                }}
                                            >
                                                <IconView />
                                            </div>
                                            <div
                                                className="action-btn-icon delete"
                                                onClick={() =>
                                                    handleDeleteModal(
                                                        row?.row?.original
                                                            ?.sellerId
                                                    )
                                                }
                                            >
                                                <IconDelete />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data || [],
        columns: columns,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region  Approve material Process
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
        setButtonText('Approve')
    }

    function handlePermission(materialId) {
        mutationStatusUpdate.mutate(materialId)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(materialId) {
        return await requestApi.post(`/material/approve`, {
            materialId
        })
    }
    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('materiallist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    return (
        <>
            <div className="material-management">
                <div className="admin-card">
                    <div class="head">
                        <h2>Designer Management</h2>
                        <div className="search-btn-group">
                            <form  {...register('materialSearch', {
                                onChange: (e) => {
                                    handleSearch(e)
                                }
                            })}
                            className="product-table-filter">
                                 <input
                                type="search"
                                name="materialSearch"
                                placeholder="Search"
                            />
                            </form>
                        </div>
                    </div>
                </div>
            { isLoading ? (
                      <TableSkeleton />
                  ) :
                  data?.data?.length > 0 ? (
                    <>
                        <TableListing table={table} className="m-0"
                          parentLink={designerview}  keyValue="sellerId"
                          isLink excludes={['Action','profilePic']}
                        />
                        <div className="pagination-wrap">
                            <div className="showing-pages">
                                <span>
                                    Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                    {Math.min(
                                        currentPage * DataLimit,
                                        data.meta.totalCount
                                    )}{' '}
                                    of {data.meta.totalCount} Designers
                                </span>
                            </div>
                            {data?.meta?.totalCount > 10 && (
                                <>
                                    {/* <div className="itemperpage-box">
                                        <span>Items per page:</span>
      
                                        <Dropdown onSelect={handleChange}>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {DataLimit}
                                            </Dropdown.Toggle>
      
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="10">
                                                    10
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="20">
                                                    20
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="30">
                                                    30
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> */}
      
                                    <Pagination
                                        total={Math.ceil(data.meta.totalCount/DataLimit)}
                                        current={currentPage}
                                        onChangePage={handleChangePage}
                                    />
                                </>
                            )}
                        </div>
                    </>
                ) : (
                   <div className='no-record-found'>
                      No Record Found
                   </div>
                )
                  }

                <DeleteModal
                    message={
                        <>
                            Are you sure you want to <br /> Delete this Designer ?
                        </>
                    }
                    setIsDeleteModal={setIsDeleteModal}
                    isDeleteModal={isDeleteModal}
                    handleDelete={() => handleDelete(deleteId)}
                />

                <ApproveDeclinePopup
                    ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                    setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                    setStatusUpdate={statusUpdate}
                    title={`are you sure you want to ${buttonText} ?`}
                    // handlestatus={handlestatus}
                    text={buttonText}
                    handlePermission={() => handlePermission(statusUpdate)}
                />
            </div>

            <ImageZoomModal imageShow={imageShow} setImageShow={setImageShow}  imageGet={imageGet}/>
        </>
    )
}

export default DesignerManagement
